/**
 * watch-button.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component, Input } from "@angular/core";
import { Subject } from "../subjects/subject";
import { SharedList, WatchlistService } from "./watchlist.service";
import { UserService } from "app/auth/identity/user.service";

const test = false;

@Component({
    selector: "watch-button",
    template: `
<div
    #openOptions
    class="btn-group"
    [class.open]="openOptions.open"
    (mouseleave)="openOptions.open = false">
    <a
        *ngIf="subject && subject.incomingWatchId === null"
        (click)="watch()"
        class="btn btn-info"
        [attr.disabled]="disabled ? '' : null">
        <span class="glyphicon glyphicon-eye-open pull-left"></span>
        Add to List
    </a>
    <a
        *ngIf="subject && subject.incomingWatchId !== null"
        (click)="unwatch()"
        class="btn btn btn-warning"
        [attr.disabled]="disabled ? '' : null">
        <span class="glyphicon glyphicon-eye-close pull-left"></span>
        Remove from List
    </a>
    <button
    type="button"
    class="btn dropdown-toggle"
    [class.btn-primary]="!subject || subject.incomingWatchId === null"
    [class.btn-warning]="subject && subject.incomingWatchId !== null"
    data-toggle="dropdown"
    aria-haspopup="true"
    [attr.aria-expanded]="!!openOptions.open"
    (click)="toggleDropdown(openOptions)">
    <span class="caret"></span>
    </button>
    <ul class="dropdown-menu contain-strict right-edge">
        <li *ngIf="loading"><spinner></spinner></li>
        <li *ngFor="let list of knownLists">
            <a (click)="watchShared(list)">
                Add to <em>{{list.title}}</em>
            </a>
        </li>
        <!-- <li *ngIf="knownLists?.length > 0" role="separator" class="divider"></li> -->
        <!-- <li>
            <a (click)="loadShared()">
            Load Shared Lists...
            </a>
        </li> -->
    </ul>
    </div>
`,
    styles: [`
    .btn-group {
        margin-bottom: 20px;
        width: 100%;
    }
    a.btn {
        width: calc(100% - 26px);
     }
    .btn.dropdown-toggle {
        width: 26px;
    }
    .dropdown-menu {
        min-width: 50%;
    }
    .btn .glyphicon {
        line-height: 20px;
    }
    `]
})
export class WatchButtonComponent
{
    constructor (
        private watchlist : WatchlistService, private users : UserService) {/* DI */}

    @Input()
    public subject : Subject;

    @Input()
    public disabled : boolean = false;

    public watch () : void
    {
        this.watchlist.watchSubject(this.subject).subscribe();
    }

    public unwatch () : void
    {
        this.watchlist.unwatch(this.subject).subscribe();
    }

    public watchShared(targetList : SharedList) : void
    {
        this.watchlist.watchShared(this.subject, targetList).subscribe();
    }

    public knownLists : SharedList[] = [];
    private readExistingLists () {
        this.knownLists = [];
        Array.from(this.watchlist.sharedListsByGroup.values())
            .forEach((groupLists : SharedList[]) => {
                this.knownLists = this.knownLists.concat(groupLists)
            });
        this.knownLists.sort((la, lb) => la.title.localeCompare(lb.title));
    }

    public ngOnInit() {
        this.readExistingLists();
    }

    public loading : boolean = false;

    public loadAllShared() : void
    {
        this.loading = true;
        this.watchlist.requestListsForAll(this.users.self.sharedListGroups).subscribe(_ => {
            this.readExistingLists();
            this.loading = false;
        });
    }

    public toggleDropdown (openOptions : {open: boolean}) {
        if (openOptions.open) {
            openOptions.open = !openOptions.open;
        } else {
            openOptions.open = true;
            if (this.watchlist.hasLoadedSharedLists.size < this.users.self.sharedListGroups.length) {
                this.loadAllShared();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/watchlist/watch-button.component.ts